import { DateUtil, Navigation, StringUtil } from "@mcleod/core";
import { AutogenLayoutCarrierActivities } from "./autogen/AutogenLayoutCarrierActivities";
import { DataSourceExecutionEvent, Snackbar } from "@mcleod/components";

export class CarrierActivities extends AutogenLayoutCarrierActivities {
    widgetOnClick() {
        Navigation.navigateTo("lme/crm/CarrierSalesBoardMultiProfile");
    }

    sourceCarrierSalesAfterExecution(event: DataSourceExecutionEvent) {
        const message = this.mainDataSource?.data[0]?.get("message");
        if (!StringUtil.isEmptyString(message)) {
            Snackbar.showWarningSnackbar(message);
        } else {
            this.labelTotalCount.text = this.mainDataSource.data.length.toString();
            this.labelPastDueCount.text = this.mainDataSource.data.filter((modelRow) => {
                const dueDate = modelRow.getDate("date_due");
                const today = new Date();
                return dueDate.getFullYear() < today.getFullYear() ||
                    dueDate.getMonth() < today.getMonth() ||
                    dueDate.getDate() < today.getDate();
            }).length.toString();
            this.labelTodayCount.text = this.mainDataSource.data.filter((modelRow) => {
                const dueDate = modelRow.getDate("date_due");
                const today = new Date();
                return dueDate.getFullYear() === today.getFullYear() &&
                    dueDate.getMonth() === today.getMonth() &&
                    dueDate.getDate() === today.getDate();
            }).length.toString();
        }
    }
}